import React from 'react'
import Pg9 from '../../../myapp/services/add-money/Pg/Pg9.jsx'

function PG9Page() {
  return (
    <Pg9/>
  )
}

export default PG9Page